import { render, staticRenderFns } from "./leftTop.vue?vue&type=template&id=4230a6a6&scoped=true"
import script from "./leftTop.vue?vue&type=script&lang=js"
export * from "./leftTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230a6a6",
  null
  
)

export default component.exports